module.exports = __webpack_public_path__ + "img/crown.ebb4aaad.png";